import { render, staticRenderFns } from "./SeniorCaseItem.vue?vue&type=template&id=64d609e9&scoped=true&"
import script from "./SeniorCaseItem.vue?vue&type=script&lang=js&"
export * from "./SeniorCaseItem.vue?vue&type=script&lang=js&"
import style0 from "./SeniorCaseItem.vue?vue&type=style&index=0&id=64d609e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d609e9",
  null
  
)

export default component.exports